import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { FormField } from '../form-field/form-field';

export type TextareaProps = {
  invalid?: boolean;
  label?: React.ReactNode;
  error?: React.ReactNode;
  help?: React.ReactNode;
  noResize?: boolean;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef(
  (
    { invalid, label, error, help, noResize, className, ...textareaProps }: TextareaProps,
    ref: React.Ref<HTMLTextAreaElement>
  ) => {
    const classNames = classnames(className, 'airtame-textarea', {
      'airtame-textarea--no-resize': noResize,
    });

    return (
      <FormField
        label={label}
        invalid={invalid}
        labelPlacement="top"
        error={error}
        help={help}
        disabled={textareaProps.disabled}
        className={classNames}
      >
        <textarea className="airtame-textarea__input" ref={ref} {...textareaProps} />
      </FormField>
    );
  }
);

Textarea.displayName = 'Textarea';
